import { useRoute } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'

import { applicationDetails } from './function'

export const useGetApplicationDetails = (hash: string, isEnabled?: boolean) => {
  const { name } = useRoute()
  const isLOS = name === 'BrandsLOS' ? true : false

  return useQuery({
    queryFn: () => applicationDetails(hash, isLOS),
    queryKey: ['cc/brands', hash, 'applicationDetails'],
    enabled: Boolean(hash),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    isEnabled,
  })
}

export const useIsApplicationV2 = (hash: string): boolean => {
  const { data: applicationDetails } = useGetApplicationDetails(hash, false)
  const isV2 = Boolean(applicationDetails?.v2)

  return isV2
}

export const useGetApplicationPartnerId = (hash: string): number => {
  const { data: applicationDetails } = useGetApplicationDetails(hash, false)
  const partnerId = Number(applicationDetails?.partnerId)

  return partnerId
}
